/// <reference types="react-scripts" />

export const API_ENDPOINT =
  process.env.REACT_APP_ENDPOINT ??
  "http://localhost:8080/v1/api";

export const firebaseConfig = {
  apiKey: "AIzaSyByjnsdLW7Pyo4l36T_rWQcuHBpuKD2NNw",
  authDomain: "waleko-personal.firebaseapp.com",
  databaseURL: "https://waleko-personal.firebaseio.com",
  projectId: "waleko-personal",
  storageBucket: "waleko-personal.appspot.com",
  messagingSenderId: "449168051873",
  appId: "1:449168051873:web:08aecc1ad38afd08996ae0",
  measurementId: "G-3DGVZ2V48D"
};
